import { createSelector } from '@reduxjs/toolkit';

import { getGlobalDepartments } from 'utils/personnelHelper';

import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { getLanguageDictionary, getTimezone } from 'reducers/utils';

import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filtersSelectors } from '../Modules/filters';

import {
  transformBasicPersonnel,
  transformPersonnelList,
  transformRaw,
} from 'utils/DataTransform/Personnel/PersonnelList';
import { selectstate } from '../Modules/typeOfPersonnels';
import { transformPersonnelDetails } from 'utils/DataTransform/Personnel/PersonnelDetails';
import { getSecurityCompanyFeatures } from 'reducers/securityCompany';
import { get } from 'lodash';

export const getPersonnelDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getLanguageDictionary,
  getTimezone,
  getGlobalDepartmentRecords,
  state => state.globalList.users.record,
  getSecurityCompanyFeatures,
  (details, dict, tz, globalDepartmentRecords, users, subscribedFeatures) => {
    if (!details) {
      return {};
    }
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    const transformedList = transformPersonnelDetails({
      data: details,
      languageList: dict,
      timeZone: tz,
      subscribedFeatures,
      shiftDetails: [],
      globalUserRecord: users,
      globalDepartmentList,
    });
    return transformedList;
  },
);

export const getPersonnelDetails = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details) {
      return {};
    }
    return details;
  },
);

export const getPersonnelListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  state => state.utils.languageDictionary,
  (personnelList, globalDepartmentRecords, languageDictionary) => {
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);

    if (!personnelList) {
      return [];
    }
    const list = transformPersonnelList({
      list: personnelList,
      languageDictionary,
      globalDepartmentList,
    });
    return list;
  },
);

export const getPersonnelListRawTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  personnelList => {
    if (!personnelList) {
      return [];
    }
    const list = transformRaw(personnelList);
    return list;
  },
);

export const getTotalRowsCount = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => rowsCount,
);
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getPersonnelFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);

export const getPersonnelFilterKey = createSelector(
  filtersSelectors.getFilterKey,
  filterKey => filterKey,
);

export const getCleaners = createSelector(selectstate, cleanerList => {
  if (!cleanerList.cleaners || cleanerList.length === 0) {
    return [];
  }
  return transformBasicPersonnel(cleanerList.cleaners);
});

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

export const getPersonnelRoles = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    const roles = get(details, 'general.roles');
    return roles;
  },
);
export const getPersonnelUserId = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    const userID = get(details, 'general.id');
    return userID;
  },
);

export const getPersonnelListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  personnelList => {
    if (!personnelList) {
      return [];
    }
    return personnelList;
  },
);

export const getPersonnelDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    return details;
  },
);
